export function toUrlQueryString(params) {
    let string = '';
    for (const [key, value] of Object.entries(params)) {
        if (key) {
            const append = (v) => {
                const vType = typeof v;
                if (v != null && (vType !== 'number' || Number.isFinite(v))) {
                    string += (string ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(v.toString());
                }
            };
            if (Array.isArray(value)) {
                value.forEach(append);
            }
            else {
                append(value);
            }
        }
    }
    return string;
}
